import { RJSFSchema, UiSchema } from '@rjsf/utils'
import validator from '@rjsf/validator-ajv8'
import { merge, pick } from 'lodash'

import Form, { extractUiSchema } from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/components/Form'
import proxyAction from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/globalActions/proxy.json'
import useDatasource from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/hooks/useDatasource'
import useSearchParams from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/hooks/useSearchParams'
import { Datasource } from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/interfaces'

export function Legacy() {
  const [datasource, setDatasource] = useDatasource(true)

  const datasourceActions: typeof datasource.actions = { _proxy: proxyAction, ...datasource.actions }
  const [searchParams] = useSearchParams()

  const activeActionKey = searchParams.get('action')!

  const schema: RJSFSchema = {
    type: 'object',
    properties: {
      method: {
        type: 'string',
        enum: ['post', 'patch', 'put', 'get', 'delete', 'options', 'head']
      },
      path: {
        type: 'string'
      }
    }
  }

  const uiSchema: UiSchema<any, typeof schema> = merge(extractUiSchema(schema), {
    'ui:options': {
      submitButtonOptions: {
        norender: true
      }
    }
  })
  const handleLegacyChange = (value: Pick<Datasource['actions'][string]['legacy'], 'method' | 'path'>) => {
    if (!activeActionKey) return

    setDatasource(datasource => ({
      ...datasource,
      actions: {
        ...datasource.actions,
        [activeActionKey]: {
          ...(activeActionKey === '_proxy' ? proxyAction : {}),
          ...datasource.actions[activeActionKey],
          legacy: { ...pick(value, ['method', 'path']) }
        }
      }
    }))
  }

  return (
    <div className="flex flex-1 flex-col">
      <Form
        className="flex flex-1 flex-col gap-4 p-4"
        validator={validator}
        schema={schema}
        uiSchema={uiSchema}
        formData={{ key: activeActionKey, ...pick(datasourceActions[activeActionKey].legacy, ['path', 'method']) }}
        onChange={event => handleLegacyChange(event.formData)}
      />
    </div>
  )
}
